// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxChevronLeftIcon = (props: FxSvgProps) => (
  <FxSvg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8821 2.31312C10.6869 2.11786 10.3703 2.11786 10.175 2.31312L5.31308 7.17505C4.85747 7.63066 4.85747 8.36935 5.31308 8.82496L10.175 13.6869C10.3703 13.8822 10.6869 13.8822 10.8821 13.6869C11.0774 13.4916 11.0774 13.175 10.8821 12.9798L6.02019 8.11786C5.9551 8.05277 5.9551 7.94724 6.02019 7.88215L10.8821 3.02023C11.0774 2.82496 11.0774 2.50838 10.8821 2.31312Z"
    />
  </FxSvg>
);
